export default [
    {
        name: 'Communications', icon: 'dynamic_feed', path: 'communications',
        items: [
            { name: 'Messages', icon: 'drafts', route: 'COMMUNICATION.messages', roleRequired: 'messages', count: 0 },
            { name: 'Voicemail', icon: 'voicemail', route: 'COMMUNICATION.voicemail', roleRequired: 'voicemail', count: 0 },
            { name: 'Calls', icon: 'phone', route: 'COMMUNICATION.call-log', roleRequired: 'calls', count: 0 },
            { name: 'Contacts', icon: 'contact_page', route: 'COMMUNICATION.contacts', roleRequired: 'contacts', count: 0 },
            { name: 'Notifications', icon: 'chat', route: 'COMMUNICATION.notifications', roleRequired: 'notifications', count: 0 },
            { name: 'Appt Requests', icon: 'chat', route: 'COMMUNICATION.appointment-requests', roleRequired: 'group_page.admin', count: 0 },
            { name: 'Chat', icon: 'chat_bubble', route: 'COMMUNICATION.chat', roleRequired: 'chat', count: 0 },
            { name: 'Bulletin', icon: 'forward_to_inbox', route: 'COMMUNICATION.bulletin', roleRequired: 'bulletin.admin', count: 0 },
            // { name: 'Notifications', icon: 'speaker_phone', route: '', count: 0 },
            // { name: 'Chat', icon: 'chat', route: '', count: 3 },
            // { name: 'Bulletins', icon: 'announcement', route: '', count: 134 },
        ]
    },
    {
        name: 'PCP Patients', icon: 'tag_faces', path: 'patients',
        items: [
            // { name: 'Census', icon: 'assignment', route: 'PATIENTS.view', count: 0 },
            { name: 'Transfers', icon: 'transfer_within_a_station', route: 'PATIENTS.patients-transfer', roleRequired: 'transfer', count: 0 },
            { name: 'Active Patients', icon: 'chat', route: 'PATIENTS.notifications', roleRequired: 'notifications', count: 0 },
        ]
    },
    {
        name: 'Scheduling', icon: 'event', url: 'https://scheduling.youcallmd.com', path: 'scheduling',
        items: [
            { name: 'Scheduling', icon: 'event', route: 'SCHEDULING', roleRequired: 'scheduling.admin', count: 0,
                childItems: []
                /*
                    {name: 'Pods', type: 'chat_bubble', params: {report_id: 'vmm'}}
                ]
                */

             },            
            { name: 'Reports', icon: 'list_alt', route: 'SCHEDULING.report', roleRequired: 'pcp_admin', count: 0,
                childItems: []
                    //{name: 'Scheduling', icon: 'chat_bubble', params: {report_id: 'vmm'}}
                //]
            },
            
            //{ name: 'Legacy Scheduling', icon: 'event', route: 'URL.$GETTER(app/v2SchedulingUrl)', roleRequired: 'scheduling.legacy', count: 0 },
            
        ]
    },
    {
        name: 'EMR', icon: 'health_and_safety', path: 'emr',
        items: [
            { name: 'EMR', icon: 'calendar_month', route: 'EMR.schedule', roleRequired: 'emr_never',  count: 0 },
        ]
    },    
    {
        name: 'Administration', icon: 'settings', path: 'administration',
        items: [
            { name: 'Profile', icon: 'settings', route: 'ADMINISTRATION.profile',  count: 0 },
            { name: 'Add User', icon: 'person_add', route: 'ADMINISTRATION.user', roleRequired: 'user', count: 0 },
            { name: 'Edit Group', icon: 'groups', route: 'ADMINISTRATION.group', roleRequired: 'group', count: 0 },
            { name: 'Support Ticket', icon: 'contact_support', route: 'ADMINISTRATION.ticket',  count: 0 },
        ]
    }
];
